import styled from "styled-components";

export const TagContainer = styled.span<{ $color?: string }>`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    max-width: 100%;
    padding: 4px 12px;
    border-radius: 6px;
    background-color: ${({ $color }) => $color || "#2b2b2b"};
    color: #fff;
    font-family: "Roboto";
    font-size: 15px;
    font-weight: 300;
    line-height: 20px;
    white-space: nowrap;
    user-select: none;
`;

export const TagIcon = styled.span<{ $src: string }>`
    flex-shrink: 0;
    display: block;
    width: 20px;
    height: 20px;
    background-color: currentColor;
    -webkit-mask: url(${({ $src }) => $src}) center / contain no-repeat;
    mask: url(${({ $src }) => $src}) center / contain no-repeat;
`;

export const TagLabel = styled.span`
    display: block;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
`;
